import { Component } from "@angular/core";

@Component({
    selector: 'app-easter-single-video',
    imports: [],
    template: `
     <div class="tw-w-full tw-px-5 md:tw-px-10 tw-bg-v4-yellow-1 tw-py-10 gradient-shadow-top tw-flex tw-justify-center">
        <iframe
            class="tw-w-full lg:tw-w-3/4 tw-h-[40vh] lg:tw-h-[82vh]"
            loading="lazy"
            title="Celebrating 2000+ Trustpilot Reviews - Thank you for your support!"
            width="500"
            height="300"
            src="https://www.youtube.com/embed/RfYDtBNiYCE?feature=oembed"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        ></iframe>
     </div>
  `
})
export class EasterSingleVideoComponent { }
